
const digest = 'a7623eb638565d63f1f65e360421b40533bcb4f7b1e9d2532820abb54c5510f5';
const classes = {"wrapper":"_wrapper_e7gdd_1","controls":"_controls_e7gdd_1","button":"_button_e7gdd_7","barcode":"_barcode_e7gdd_11","errorMessage":"_errorMessage_e7gdd_16"};
const css = `._wrapper_e7gdd_1 ._controls_e7gdd_1 {
  display: flex;
  flex-direction: row;
  gap: 15px;
  align-items: center;
}
._wrapper_e7gdd_1 ._controls_e7gdd_1 ._button_e7gdd_7 {
  width: fit-content;
}

._barcode_e7gdd_11 {
  display: flex;
  justify-content: center;
}

._errorMessage_e7gdd_16 {
  max-width: 550px;
  color: #d81616;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  